export { default as Logo } from "@/components/logo";
export { default as Classes} from "@/styles/components/main-area/_index.module.scss";
